import { render, staticRenderFns } from "./Enable.vue?vue&type=template&id=01c05ac8&"
import script from "./Enable.vue?vue&type=script&lang=js&"
export * from "./Enable.vue?vue&type=script&lang=js&"
import style0 from "./Enable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
